<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Form - Penjualan 
                <div class="card-header-actions">
                <button  v-if="(model.isposted==0)" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="7" xl="8">
                    <b-row>
                        <b-col md="6">
                        <b-input-group>
                            <b-input-group-prepend><label>No.Trx / No. Bill</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Tgl. Penjualan</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" :max="maxDateDeliv"  :state="!$v.model.tanggal.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-input-group >
                        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.CustName" :state="!$v.model.customer_id.$error"></b-form-input>
                        <b-input-group-append v-if="!isEdit">
                        <b-btn variant="primary" @click="lkuCustomerShow=true"> <i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Keterangan</label></b-input-group-prepend>
                        <b-form-input v-model="model.Uraian"  placeholder="Note/Description"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col >
                    <!-- <b-input-group>
                      <b-input-group-prepend><label>Order Type</label></b-input-group-prepend>
                        <b-form-select v-model="model.orderType" :plain="true" :options="orderTypes"></b-form-select>
                    </b-input-group> -->
                    <b-input-group >
                        <b-input-group-prepend><label>Delivery Order No.</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.nomorDeliv" ></b-form-input>
                        <b-input-group-append v-if="!isEdit">
                        <b-btn text="Button" @click="lkuCustomerdeliveryShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                    <!-- <b-input-group>
                        <b-input-group-prepend><label>Alamat Kirim</label></b-input-group-prepend>
                        <b-form-input v-model="model.DelivLoc" readonly></b-form-input>
                    </b-input-group> -->
                    <b-input-group >
                        <b-input-group-prepend><label>Term Of Payment</label></b-input-group-prepend>
                        <b-form-input v-model="model.Term" readonly></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Sales/Marketing</label></b-input-group-prepend>
                        <b-form-input v-model="model.SalesEx"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                        </b-input-group-append>
                    </b-input-group>

                </b-col>
              </b-row>
            <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblOrderLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="ordLines.items"
                    :fields="ordLines.fields"
                    :current-page="ordLines.page"
                    :per-page="ordLines.limit"
                    show-empty
                    >
                    <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                    </template>
                    <template v-slot:cell(itemname)="data">
                        {{data.item.itemname}} <span v-if="(data.item.remark)"> | {{data.item.remark}}</span>
                    </template>
                    <template v-slot:cell(qty)="data">
                        {{data.item.qty}} {{data.item.unitsize}}
                    </template>
                    <template v-slot:cell(unitprice)="data">
                        {{data.item.unitprice|numFormat}}
                    </template>
                    <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat}}
                    </template>
                    
                    <template v-slot:cell(ttlamount)="data">
                        {{data.item.ttlamount|numFormat}}
                    </template>
                    <template v-slot:cell(nilainett)="data">
                        {{data.item.nilainett|numFormat}}
                    </template>
                    <template v-slot:cell(grossOrder)="data">
                        {{data.item.grossOrder|numFormat}}
                    </template>
                    <template v-slot:cell(discOrder)="data">
                        {{data.item.discOrder|numFormat}}
                    </template>
                    <template v-slot:cell(nettOrder)="data">
                        {{data.item.nettOrder|numFormat}}
                    </template>
                    <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editOrderLines(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        |
                        <a href="javascript:void(0)" class="text-danger" @click="delOrderLines(data.index)">
                            <i class="fa fa-trash"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                        <b-card class="row-details-form">
                            <b-row  align-h="center">
                                <b-col lg="7" >
                                    <b-input-group>
                                        <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
                                        <b-form-input readonly v-model="ordLinesObj.itemname" @keyup.13.native="lkuItemShow=true" :state="!$v.ordLinesObj.itemno.$error"></b-form-input>
                                        <b-input-group-append>
                                        <b-btn text="Button" @click="lkuItemShow=true">
                                            <i class="fa fa-search"></i>
                                        </b-btn>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-input-group-prepend><label>Item Code</label></b-input-group-prepend>
                                        <b-form-input v-model="ordLinesObj.partnumber" readonly></b-form-input>
                                        <b-input-group-prepend><span class="input-group-text" >unit size</span></b-input-group-prepend>
                                        <b-form-input v-model="ordLinesObj.unitsize" readonly></b-form-input>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col lg="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >Price</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{uanguser}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.unitprice" :precision="2" 
                                                :state="!$v.ordLinesObj.unitprice.$error" ></my-number>
                                            </b-input-group>                                          
                                        </b-col>
                                        <b-col lg="3">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label style="text-align:right;">Discount</label></b-input-group-prepend>
                                                <my-number v-model="ordLinesObj.disc" :precision="0" ></my-number>
                                                <b-input-group-append><span class="ml-1 pt-2 mr-2"><i class="fa fa-percent"></i></span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >   
                                    <b-row no-gutters>
                                        <b-col lg="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Nett Price</label></b-input-group-prepend>
                                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.nettprice" :precision="2" ></my-number>
                                            </b-input-group>                                          
                                        </b-col>
                                        <b-col lg="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label style="text-align:right;">&nbsp;</label></b-input-group-prepend>
                                                <b-form-checkbox  class="ml-1 mt-2" v-model="ordLinesObj.priceinclvat" value=1 unchecked-value=0 disabled >Price Incl. VAT</b-form-checkbox>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >   

                                </b-col>
                                <b-col lg="5">
                                    <b-row no-gutters>
                                        <b-col lg="5">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Qty. Order</label></b-input-group-prepend>
                                                <b-form-input v-model="ordLinesObj.qty" type="number"  :state="!$v.ordLinesObj.qty.$error" class="mr-1"></b-form-input>
                                            </b-input-group>                                          
                                        </b-col>
                                        <b-col lg="6">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label style="text-align:right;">PPN (VAT)</label></b-input-group-prepend>
                                                <b-form-radio-group v-model="ordLinesObj.kenappn"  class="mt-1 bg-light" >
                                                    <b-form-radio value="1">Yes</b-form-radio>
                                                    <b-form-radio value="0">No</b-form-radio>
                                                </b-form-radio-group>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >   

                                    <b-row no-gutters>
                                        <b-col lg="8">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label >Amount Due</label></b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="ordLinesObj.nilainett" :precision="2" ></my-number>
                                                <b-input-group-prepend>
                                                    <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                                                </b-input-group-prepend>
                                            </b-input-group>
                                        </b-col>
                                    </b-row >   
                                    <b-row class="justify-content-center mt-1" >
                                        <div style="width:400px;">
                                            <b-input-group >
                                                <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                                <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-success mr-1" @click="saveOrderLines()">Update</b-button>
                                                </b-input-group-append>
                                                <b-input-group-append>
                                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-card>
                    </template>
                    <template v-slot:cell(empty)="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                    <template v-slot:cell(emptyfiltered)="scope">
                        <h4>{{ scope.emptyFilteredText }}</h4>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="5">
                        <b-row>
                        <b-button size="sm" class="ml-3" @click.stop="addOrderLines" >Add item</b-button>                          
                        <div class="ml-2">
                            Showing
                            {{(ordLines.page - 1) * ordLines.limit + 1}}
                            to
                            {{ordLines.page * ordLines.limit}}
                            <strong>
                            of
                            {{ordLines.total}}
                            entries </strong>
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="3" >
                        <div class="pt-1">
                            Limit per page
                            <input type="number" style="width:80px;" v-model="ordLines.limit"/>
                        </div>
                    </b-col>        
                    <b-col cols="4">            
                    <b-pagination
                        align="right"
                        :total-rows="ordLines.total"
                        :per-page="ordLines.limit"
                        v-model="ordLines.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
            </b-card>    


            <b-row align-h="between" class="mt-1">
                <b-col lg="8" xl="7">
                    <div style="display:block;" v-if="(this.model.bill2group==1)">
                    <!-- <div style="display:block;"> -->
                        <h4>LAPORAN PENJUALAN GABUNGAN</h4>
                        <b-input-group >
                            <b-input-group-prepend><label>Customer Induk</label></b-input-group-prepend>
                            <b-form-input v-model="model.Bill2CustName" readonly style="width:40% !important;"></b-form-input>
                            <b-input-group-append>
                            <b-btn text="Button" @click="lkuSalesbinderShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
                            </b-input-group-append>
                            <b-input-group-prepend><span class="p-2">Invoice #</span></b-input-group-prepend>
                            <b-form-input v-model="model.invoiceno" readonly ></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Tgl.Laporan</label></b-input-group-prepend>
                            <b-form-input v-model="model.BinderTgl" readonly></b-form-input>
                            <b-input-group-prepend><span class="p-2">Uraian</span></b-input-group-prepend>
                            <b-form-input v-model="model.BinderUraian" readonly style="width:40% !important;"></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Total Laporan</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <b-form-input v-model="model.BinderTotal" readonly></b-form-input>
                            <b-input-group-prepend><span class="p-2">Rekap Unit</span></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <b-form-input v-model="model.BinderTotalRekap" readonly></b-form-input>
                        </b-input-group>
                    </div>

                    <div style="display: flex; justify-content: flex-end" class="mt-3">
                        <button class="btn btn-primary" @click="close()" v-if="(model.isposted==1)"> <i class="fa fa-close"></i> Close</button>
                        <div style="width:353px;" v-if="(model.isposted==0)">
                            <b-input-group >
                                <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                                <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                <b-input-group-append>
                                    <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                                </b-input-group-append>
                                <b-input-group-append>
                                    <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </div>

                </b-col>
                <b-col lg="4">
                    <div class="text-right">
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">subtotal</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlgross" :precision="2" disabled></my-number>
                        </b-input-group>
                        <!-- <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcDisc" :plain="true" :options="calcuationDisc" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" :readonly="(model.calcDisc===1)"></my-number>
                        </b-input-group> -->
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Discount</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttldiskon" :precision="2" ></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">Netto</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend>
                            <b-form-select style="width:158px;"  v-model="model.calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                            </b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlvat" :precision="2" :readonly="(model.calcVAT===1)"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                        </b-input-group>
                    </div>
                </b-col>
            </b-row>


        </b-card>
        <b-modal v-model="lkuCustomerdeliveryShow" size="lg" :hide-footer="true" title="Daftar Delivery Order" :centered="true">
            <lku-customerdelivery @click="onSelectLkuCustomerdelivery" :formdata="lkuDeliveryData"></lku-customerdelivery>
        </b-modal>      
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>
        <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
        <lku-salesae @click="onSelectsales"></lku-salesae>
        </b-modal>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="Daftar Item"  :centered="true">
            <lku-item @click="onSelectLkuItem" :formdata="lkuItemData"></lku-item>
        </b-modal>        
        <b-modal v-model="lkuSalesbinderShow" size="lg" :hide-footer="true" title="Laporan Penjualan Gabungan" :centered="true">
            <lku-salesbinder @click="onSelectSalesbinder"></lku-salesbinder>
        </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>
<style lang="scss">

    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuCustomerdelivery from "../lookup/lkuCustomerDelivery";
import lkuItem from "../lookup/lkuItemLazzy";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuSalesbinder from "../lookup/lkuSalesbinder";
import penjualan from "../../apis/bakerysales";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber, lkuCustomerdelivery, lkuItem, lkuCustomer, lkuSalesae, lkuSalesbinder},
  mixins: [validationMixin],
    validations: {
            model: {
                tanggal: { required },
                customer_id: { required },
                matauang: { required },
                ttlamtdue: { required },
            },
            ordLinesObj: {
                itemno: { required },
                unitprice: { required },
                qty: { required },
            },
    }, 

  data() {
    return {
        saveEnabled:true,
          isLoading:false,
          isEdit:false,
            inputBerlanjut: 0,
            inputLineBerlanjut: 0,
            lkuCustomerdeliveryShow:false,
            lkuItemShow:false,
            lkuItemData:{},
            lkuDeliveryData:{},
            lkuCustomerShow:false,
            lkuSalesShow:false,
        lkuSalesbinderShow:false,

        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        maxDateDeliv:'',
        uanguser: this.$store.state.user.matauang,
            model: {
                matauang:this.$store.state.user.matauang, 
                compcode:this.$store.state.user.compcode,
                tanggal: '',
                customer_id: '',
                matauang: this.$store.state.user.matauang, calcVAT:1, calcDisc:0, 
                nofaktur: '',
                tglfaktur: '',
                ttlamtdue: '',
                kursPPN: 1,ttldiskon:0, iscash:0, isposted:0
            },

            ordLinesObj: {
                itemno:'', 
                itemname: '',
                remark: '',
                qty: 0,
                nettOrder: 0,
                unitprice:0,
                kenappn:1,printhide:0,
                priceDiscPc:0,discPrice:0,priceNett:0,nettprice:0,disc: 0,

            },
            calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
            calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
            calcPPh:1,
            ordLines: {
                items: [],
                selected:{},
                fields: [
                    {key: 'index', label: 'No.' ,thStyle: "width:40px"},                    
                    {
                        key: "itemname",
                        label: "Item Name",
                    },
                    {
                        key: "partnumber",
                        label: "itemcode",
                    },
                    {
                        key: "unitsize",
                        label: "Unit Size",
                    },
                    {
                        key: "qty",
                        label: "Quantity",
                        thClass: "text-center",
                        tdClass: "text-center"
                    },
                    {
                        key: "unitprice", 
                        label: "Price",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "nilai", 
                        label: "Value Order",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "disc", 
                        label: "Saving Value",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "nilainett", 
                        label: "Due/Nett",
                        thStyle: "width:110px",
                        thClass: "text-right",
                        tdClass: "text-right"
                    },
                    {
                        key: "action",
                        label: "Action",
                        thStyle: "width:40px",
                        thClass: "text-center",
                    },
                ],
                page: 1,
                limit: 5,
                total: 0,
            },
            orderTypes:['Non Konsinyasi','Konsinyasi'],
            paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}]
    };
},
  computed: {
    invalidOrdLines() {
    //   this.ordLines.kenappn= (this.ordLines.ppn != 0); 
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    disc() {
      return this.ordLinesObj.disc || 0;
    },
    qty() {
      return this.ordLinesObj.qty || 0;
    },
    unitprice() {
        return this.ordLinesObj.unitprice || 0;
    },
    nettprice() {
        return this.ordLinesObj.nettprice || 0;
    }
  },
  created: async function(){
    if (this.$route.params.SaleHdrId)  {
          toastr.info('Loading Order Detail, please wait')
          try {
            const data = await penjualan.detail(this.$route.params);  
            const row = data[0];
            // this.saveEnabled=(row.send2wf === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.ordLines.items=data[1];
            this.ordLines.items.forEach(element => {
                element.unitprice = element.hargajual
            });
            this.ordLines.total=this.ordLines.items.length;
            this.calcTotalDtlOrder();
            this.isEdit = true;
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.tanggal  = moment().format('YYYY-MM-DD');
        }


        this.$watch('ordLinesObj.qty', function(newVal) {
            if (newVal==this.ordLinesObj.qty) {
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('ordLinesObj.unitprice', function(newVal) {
            if (newVal==this.ordLinesObj.unitprice) {
                this.ordLinesObj.nettPrice = parseFloat(newVal) * (100-parseFloat(this.ordLinesObj.disc ||0 )) / 100;        
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('ordLinesObj.disc', function(newVal) {
            if (newVal==this.ordLinesObj.disc) {
                this.ordLinesObj.discPrice = parseFloat((this.ordLinesObj.unitprice || 0)) * parseFloat(newVal) / 100;
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }     
        });            
        this.$watch('ordLinesObj.discPrice', function(newVal) {
            if (newVal==this.ordLinesObj.discPrice) {
                this.ordLinesObj.nettPrice = parseFloat((this.ordLinesObj.unitprice || 0)) -parseFloat(newVal ||0 );        
                if (this.ordLinesObj.nettPrice>0) {
                    this.ordLinesObj.printhide=0;
                } else {
                    this.ordLinesObj.printhide=1;
                }
                setTimeout(() => {
                    this.calcAmount();                    
                }, 100);
            }
        });            
        this.$watch('model.ttldiskon', function(newVal) {
            this.model.ttlnetto=this.model.ttlgross-this.model.ttldiskon;
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        });            
        this.$watch('model.ttlvat', function(newVal) {
            this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
        });         
  },
  sockets: {
    salesBinderTrx: function(data) {
      if ((data.customer_id == this.model.Bill2CustId)  && (!(this.model.BinderId))) {
        this.cekBinder();
      }
    }
  },  
  methods: {
    cekBinder: async function(){
        if ((this.model.bill2group==1) && (!(this.model.BinderId))) {
	        // SQLEXEC(HandleDBServer,"SELECT TOP 1 * FROM BookSalesBinder WHERE (agencid=?Customer.agencid AND isComplet=0) ORDER BY tanggal DESC","SalesBinder")   
            booksales.cekBinder({customer_id: this.model.Bill2CustId, tanggal: moment(this.tanggal).format('YYYY-MM-DD')}).then(_selected => {
                        this.model.BinderId = _selected.BinderId;
                        this.model.Bill2CustId = _selected.customer_id;
                        this.model.Bill2CustName = _selected.CustName;
                        this.model.BinderTgl = _selected.BinderTgl;
                        this.model.BinderTotal = _selected.BinderTotal;
                        toastr.info(`Laporan Penjualan Gabungan ${_selected.CustName.toUpperCase() }`,'INFORMATION',10000);

                    })
                    .catch(err => {
                        console.log('cekBinder Error -> ', err);
                    });

        } else {
            if (this.model.bill2group==0) {
                this.model.BinderId = '';
                this.model.Bill2CustId = '';
                this.model.Bill2CustName = '';
                this.model.BinderTgl = '';
                this.model.BinderTotal = '';
            }
        }
    },
    closeOrderLines: function(){
        const opened= this.ordLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addOrderLines : function () {
        this.closeOrderLines();
        const obj={_showDetails:true};
        this.ordLines.selected = obj;
        for (var key in this.ordLinesObj) {
            this.ordLinesObj[key] = '';
        }
        this.ordLinesObj.unitsize='EACH';
        this.ordLinesObj.qty = 1;
        this.ordLinesObj.qtyUndefined = 0;
        this.ordLinesObj.nilainett= 0;
        this.ordLinesObj.nettprice= 0;
        this.ordLinesObj.disc=0;
        this.ordLines.items.push(obj);
        this.ordLines.total=this.ordLines.items.length;
        setTimeout(() => {
            const bfore = this.ordLines.page;
            const after =Math.ceil((this.ordLines.total)/this.ordLines.limit);
            if (bfore != after){
                this.ordLines.page =  after;                 
                toastr.info(`Move to page ${after} of total  ${this.ordLines.total} items`,'Line/Detail PR',10000);
            }
        }, 100);    
    },
    editOrderLines : function (obj,callback) {
        this.closeOrderLines();
        this.ordLines.selected = obj;
        // for (var key in this.ordLinesObj) {
        //     this.ordLinesObj[key] = '';
        // }
        // this.dimension.forEach(dim => {
        //     if (obj[`${dim.value}Txt`]) {
        //     obj[`${dim.value}Info`] = obj[`${dim.value}Txt`];
        //     }
        // });
        for (var key in obj) {
            this.ordLinesObj[key] = obj[key];
        }
        callback();
    },
    delOrderLines: function (index) {
        if (index > -1) {
            // this.ordLines.items.splice(index, 1);
            const posisi = (this.ordLines.page-1)*this.ordLines.limit;
            this.ordLines.items.splice(posisi+index, 1);
        }
        this.ordLines.total=this.ordLines.items.length;
        this.calcTotalDtlOrder();
    },
    saveOrderLines: async function (callback) {
        this.calcAmount();
        if (this.invalidOrderLines) {
            const invalidobj={};
            for (var key in this.$v.ordLinesObj) {
            if (this.$v.ordLinesObj[key].$anyError) {
                if (this.$v.ordLinesObj[key].$anyError==true) invalidobj[key] = this.$v.ordLinesObj[key];
            }
            }        
            console.log('validation ordLinesObj: ', this.ordLinesObj);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                    for (var key in this.ordLinesObj) {
                        this.ordLines.selected[key] = this.ordLinesObj[key];
                    }
                    this.calcTotalDtlOrder();
                    this.ordLines.selected._showDetails=false;
                    if (callback) callback();
                    if (this.inputLineBerlanjut==1) {
                        this.addOrderLines();
                        this.$v.ordLinesObj.$reset();
                    }

            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },    
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        if (this.invalidModel) {
            const invalidobj={};
            for (var key in this.$v.model) {
              if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
              }
            }        
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            this.isLoading=true;            
            try {

                    this.model.idDelivHdr = this.model.idDelivHdr || '';
                    this.model.nomorDeliv = this.model.nomorDeliv || '';
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    // row.terms = this.model.terms;
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    let lineno=1;
                    row.lines  = this.ordLines.items.reduce((newArr, item) => {
                        if (((item.itemno || '') != '') && (item.qty != 0)) {
                            item.lineno = lineno+1;
                            // diskonrkp += item.nilaidisc;    
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        try {
                            const hasil= await penjualan.save(row);
                            toastr.success(`Success, Penjualan No. ${hasil.nomor}`, "Save Penjualan",10000);
                            this.isLoading=false;            
                            if (this.inputBerlanjut==0){
                                this.close();
                            } else {
                                this.saveEnabled=true;            
                                const tanggal = this.model.tanggal;
                                for (var key in this.model) {
                                    this.model[key] = '';
                                }
                                this.model.tanggal = tanggal;
                                this.ordLines.items=[];
                                this.$v.model.$reset();                        
                            }
                        } catch (error) {
                            if (error.sql) {
                                toastr.error(error.sql,'ERROR MESSAGE',10000);
                            } else if (error.sqlMessage) {
                                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                            } else if (error.message) {
                                toastr.error(error.message,'ERROR MESSAGE',10000);
                            } else {
                                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                            }                                        
                        }
                    } else {
                        this.isLoading=false;            
                        toastr.error('Please fill at least 1(one) Order Detail', 'ERROR MESSAGE');
                    }
                    
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Order Error");                
            }

        }
    },
    onSelectLkuCustomerdelivery:async function (_selected) {
        // Note : apakah bisa masukkan PO lebih dari 1?
        if ((this.model.nomorDeliv) && (this.model.nomorDeliv !== _selected.nomorDeliv)) {
            toastr.error('Pilihlah Sales Order yg lain','ERROR MESSAGE',10000);
        } else {
            this.model.customer_id = _selected.customer_id;
            this.model.CustCode = _selected.CustCode;
            this.model.CustName = _selected.CustName;
            this.model.nomorDeliv = _selected.nomorDeliv;
            try { 
                const data = await penjualan.deliverydetail({ customer_id: _selected.customer_id, tanggal: moment(_selected.tanggal).format('YYYY-MM-DD') }) ;
                this.ordLines.items =[];
                this.ordLines.total = this.ordLines.limit = data.length;
                data.forEach(dl => {
                    let nilai = dl.unitprice * ((dl.qtyReceipt==0)?dl.qtyOrder:dl.qtyReceipt);
                    this.ordLines.items.push({itemno: dl.itemno, 
                            hargajual: dl.hargajual, 
                            // qty: dl.qtySent,
                            qty: (dl.qtyReceipt==0)?dl.qtyOrder:dl.qtyReceipt, 
                            disc: dl.disc || 0, 
                            discPrice: dl.discPrice, 
                            nettPrice: dl.nettPrice, 
                            nilai, 
                            nilaidisc: dl.nilaidisc, 
                            // nilainett: dl.nilainett,
                            nilainett: dl.ttlamount, 
                            dpp: dl.dpp, 
                            kenappn: dl.kenappn, 
                            ppn: dl.ppn, 
                            nilaippn: dl.nilaippn, 
                            nilaidue: dl.nilaidue, 
                            priceinclvat: dl.priceinclvat, 
                            itemname: dl.itemname, 
                            partnumber: dl.partnumber, 
                            unitsize: dl.unitsize, 
                            itemcategory: dl.itemcategory, 
                            headcategory: dl.headcategory,
                            unitprice: dl.unitprice
                            })
                });
                this.calcTotalDtlOrder();

            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        
        }
        this.lkuCustomerdeliveryShow=false;
        
    },
   onSelectLkuCustomer: async function (_selected) {
        this.lkuDeliveryData=_selected;
        //this.lkuDeliveryData.tanggal=this.model.tanggal;
        this.lkuCustomerShow=false;
        this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
        this.model.CustName = _selected.CustName.trim();
        this.model.customer_id = _selected.customer_id;
        this.model.Sell2Cust = _selected.CustCode.trim();
        this.model.Bill2CustId = _selected.Bill2CustId;
        this.model.Bill2CustName = _selected.Bill2CustName;
        this.cekBinder();
        // cek sales Binder dari group/induk

    },  
    onSelectLkuItem(lkuData) {
        this.lkuItemData=lkuData;
        this.lkuItemShow=false;

        this.ordLinesObj.itemno =  lkuData.selected.itemno;
        this.ordLinesObj.itemname = lkuData.selected.itemname
        this.ordLinesObj.partnumber =  lkuData.selected.partnumber;
        this.ordLinesObj.unitsize = lkuData.selected.unitsize;
        this.ordLinesObj.unitprice = lkuData.selected.unitprice;
        this.ordLinesObj.ISBN = lkuData.selected.ISBN;
        this.ordLinesObj.Paper = lkuData.selected.Paper;
        this.calcAmount();
    },
    onSelectsales(_selected) {
    this.model.SalesEx = `${_selected.salesae_name} ${" | "+_selected.crewnik} `;
    // this.model.SalesExCode = _selected.crewnik;
    this.model.SalesExCode = _selected.crewkey;
    this.model.salesae_id = _selected.salesae_id;
    this.lkuSalesShow = false;
    },
    onSelectSalesbinder(_selected) {
        this.model.BinderId = _selected.BinderId;
        this.model.Bill2CustId = _selected.customer_id;
        this.model.Bill2CustName = _selected.CustName;
        this.model.BinderTgl = _selected.BinderTgl;
        this.model.BinderTotal = _selected.BinderTotal;
        this.lkuSalesbinderShow = false;
    },
    calcAmount : function() {
        this.ordLinesObj.nilai = parseFloat(this.ordLinesObj.unitprice || 0) * parseFloat(this.ordLinesObj.qty || 0);
        this.ordLinesObj.nettprice = parseFloat(this.ordLinesObj.unitprice || 0) * parseFloat(this.ordLinesObj.qty || 0);
        this.ordLinesObj.nilaidisc = parseFloat(this.ordLinesObj.discPrice  || 0) * parseFloat((this.ordLinesObj.qty || 0));        
        this.ordLinesObj.nilainett = this.ordLinesObj.nilai -this.ordLinesObj.nilaidisc;
        
        // console.log('calcAmount : ', this.ordLinesObj);
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.ordLinesObj.dpp = parseFloat(this.ordLinesObj.nilainett  || 0);
        if (this.ordLinesObj.kenappn == 1) {
            this.model.grossup = 0;
            this.ordLinesObj.ppn = 11;
        } else {
            this.ordLinesObj.dpp = 0;
            this.ordLinesObj.ppn = 0;
        }

        this.ordLinesObj.nilaippn = 0.11 * this.ordLinesObj.dpp;
        this.ordLinesObj.nilaidue = this.ordLinesObj.nilainett + this.ordLinesObj.nilaippn;
        this.$forceUpdate();
    },
    calcTotalDtlOrder: function () {
        // subtotal    ttlgross
        // Discount    ttldiskon
        // Netto       ttlnetto
        // Total Amount Due        ttlamtdue
        this.model.calcVAT = this.model.calcVAT || 1;
        this.model.calcDisc = this.model.calcDisc || 0;
        let nilaidpp = 0;
        let ttlvat = 0;
        let ttlgross = 0;
        // let ttldiskon = 0;
        let totaldpp = 0;
        this.ordLines.items.forEach( function (trx) {
            if (trx.itemno) {
                nilaidpp += (trx.dpp || 0);
                ttlgross += (trx.nilainett || 0);
                // ttldiskon += (trx.nilaidisc  || 0);
                ttlvat += (trx.nilaippn || 0);
            }
        });
        this.model.nilaidpp = nilaidpp;
        this.model.ttlgross = ttlgross;
        if (this.model.calcVAT == 1){
            this.model.ttlvat = ttlvat;
        }
        // if (this.model.calcDisc == 1){
        //     this.model.ttldiskon = ttldiskon;
        // }
        this.model.ttlnetto =this.model.ttlgross-this.model.ttldiskon;
        this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    },
    close(){
      if ((this.$store.state.prevRoute.name) && !this.$store.state.prevRoute.name.includes('penjualanfrm'))  {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'bakery.penjualan'});
      }      
    }
  }
};
</script>
